/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_ClientInputs */

const cs_gdpr_type_client = /** @type {(inputs: Gdpr_Type_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient`)
};

const en_gdpr_type_client = /** @type {(inputs: Gdpr_Type_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client`)
};

/**
* | output |
* | --- |
* | "Client" |
*
* @param {Gdpr_Type_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_client = /** @type {((inputs?: Gdpr_Type_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_client(inputs)
	return cs_gdpr_type_client(inputs)
});